module.exports = __webpack_public_path__ + "static/cf-reg-italic-ext-be9cbe0e37e49cc25887308ed76b48e4.eot";